import { Personas, Permissions, Environments, Sites, Roles } from "../components/constants/GlobalConstants";
import { FeatureFlags } from "../components/constants/LocalServerConstants";

export const getSite = () => {
  let host = window.location.host;
  if (process.env.REACT_APP_ENV === Environments.LOCAL) {
    host = FeatureFlags.LOCAL_HOST ? FeatureFlags.LOCAL_HOST : "my.builders-capital";
  }

  if (host.includes(Sites.Hosts.MY) && host.includes(Sites.Hosts.MY_BUILDERS_CAPITAL)) {
    return Sites.Hosts.MY_BUILDERS_CAPITAL;
  }
  else if (host.includes(Sites.Hosts.BUILDERS_CAPITAL_SYL)) {
    return Sites.Hosts.BUILDERS_CAPITAL_SYL;
  }
  else if (host.includes(Sites.Hosts.CLS_SYL)) {
    return Sites.Hosts.CLS_SYL;
  }
  else if (host.includes(Sites.Hosts.SYL)) {
    return Sites.Hosts.SYL;
  }

  return "";
};

export const getBrand = () => {
  if (getSite() === Sites.Hosts.BUILDERS_CAPITAL_SYL || getSite() === Sites.Hosts.MY_BUILDERS_CAPITAL) {
    return Permissions.Brands.BUILDERS_CAPITAL;
  }
  else if (getSite() === Sites.Hosts.CLS_SYL) {
    return Permissions.Brands.DEFAULT;
  }
  else if (getSite() === Sites.Hosts.SYL) {
    return Permissions.Brands.CUSTOM;
  }

  return Permissions.Brands.BUILDERS_CAPITAL;
};

export const getIsWhiteLabeled = () => {
  if (getBrand() === Permissions.Brands.BUILDERS_CAPITAL) {
    return false;
  }
  else {
    return true;
  }
};

export const whoAmI = (user = undefined as any, proxyUser = undefined as any) => {
  if (proxyUser && proxyUser.id) {
    user = proxyUser;
  }

  if (user.persona === Roles.SYSTEM_ADMIN) {
    return Personas.SYSTEM_ADMIN;
  }
  else if ([Roles.NATIONAL_SALES_MANAGER, Roles.SALES_MANAGER, Roles.SALES_ADMIN, Roles.SENIOR_SALES_EXECUTIVE].indexOf(user.persona) > -1) {
    return Personas.SALES_ADMIN;
  }
  else if (user.persona === Roles.BROKER_ADMIN) {
    return Personas.BROKER_ADMIN;
  }
  else if (user.persona === Roles.BROKER) {
    return Personas.BROKER;
  }
  else if (user.persona === Roles.GUARANTOR) {
    if (getBrand() === Permissions.Brands.BUILDERS_CAPITAL) {
      return Personas.NWL_GUARANTOR;
    }
    else if (getIsWhiteLabeled()) {
      return Personas.WL_GUARANTOR;
    }
  }
  else if (user.persona === Roles.LOAN_OFFICER) {
    return Personas.LOAN_OFFICER;
  }
  else if (user.persona === Roles.BRM) {
    return Personas.BRM;
  }
  else if (user.persona === Roles.SALES_ASSISTANT) {
    return Personas.SALES_ASSISTANT;
  }
 
  return Personas.UNKNOWN;
};